import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import SongItem from '../SongItem/SongItem';
import SubscriptionUnlimited from './SubscriptionUnlimited/SubscriptionUnlimited';
import SubscriptionBasic from './SubscriptionBasic/SubscriptionBasic';
import NotSubscriber from './NotSubscriber/NotSubscriber';
import NoteTitle from '../NoteTitle/NoteTitle';
import { reportAnalytics } from '../../fundialSlice';

const songSubscriptionSelector = (props) => {

  const selectSubscriberStatus = (status) => {
    switch (status) {
      case 'PremiumItem':
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_DownloadSongPagePrimum_reveald",
          eventLabel: "",
        });
        return <SubscriptionUnlimited  downloadSong={props.downloadSong} />;
      case 'RegularItem':
      case 'RegularItemWithPremiumItemUpgradeOptions':
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_DownloadSongPageUG_reveald",
          eventLabel: "",
        });
        return (
          <SubscriptionBasic
            downloadSong={props.downloadSong}
            upgradeToUnlimited={props.upgradeToUnlimited}
          />
        );
      case 'NewCustomerPremiumItem':
      case 'NewCustomerRegularItem':
      case 'NewCustomerRegularItemAndPremiumItemOptions':
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_DownloadSongPageNew_reveald",
          eventLabel: "",
        });
        return <NotSubscriber downloadSong={props.downloadSong} />;
      default:
        break;
    }
  };

  return (
      <div className='songSubscriptionSelector'>
        {props.aocDetails?.isFirstSong ? (
          <NoteTitle text='השיר שבחרתם' />
        ) : (
          <div className='song-subscription-title'>
            <span>השיר שבחרתם</span>
          </div>
        )}
        <SongItem isDisplayPlayer={true} playerSize={100} isDetailsFromLeft={true} audio={props.selectedSong} onClickSong={()=> {}}></SongItem>
        {selectSubscriberStatus(props.aocDetails?.fundialPurchaseType)}
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedSubscriber: state.fundialPage.selectedSubscriber,
    selectedSong: state.fundialPage.selectedSong,
    aocDetails: state.fundialPage.aocDetails,
  };
};

const mapDispatchToProps = {
  reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(songSubscriptionSelector);